import { isEmpty } from "validator";

export const validateCreateOriginTransportation = (validateFieldRequired, setValidateFieldRequired, name, value) => {
  let fileValidate = name.field;
  switch (fileValidate) {
    case "container":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldContainer: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldContainer: true,
      });
      return Promise.resolve();
    case "route":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldRoute: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldRoute: true,
      });
      return Promise.resolve();
    case "origin_id":
      if (!value) {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldOriginId: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldOriginId: true,
      });
      return Promise.resolve();
    case "depart_at_date":
      if (!value) {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldDepartAtDate: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldDepartAtDate: true,
      });
      return Promise.resolve();
    case "depart_at_time":
      if (!value) {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldDepartAtTime: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldDepartAtTime: true,
      });
      return Promise.resolve();
  }
};

export const validateSubmitCreateOriginTransportation = (input) => {
  let isValid = true;

  if (input.container === undefined || isEmpty(input.container)) {
    isValid = false;
  }

  if (input.origin_id == undefined) {
    isValid = false;
  }
  if (!input.destination_id) {
    isValid = false;
  }
  if (!input.depart_at_date) {
    isValid = false;
  }

  if (!input.depart_at_time) {
    isValid = false;
  }

  return { isValid: isValid };
};
